import { ApiError } from "./api";
import { state } from "./app-state";
import { LEGACY_STORAGE_KEYS, MOBILE_BREAKPOINT } from "./constants";
import { ui } from "./dom";
// session-ui.ts ⇄ editor.ts 互相引用（hardLogout / abortEditor），运行期调用，安全。
import { abortEditor } from "./editor";
import { closeHistory } from "./history";
import { closeModal } from "./modal";
import { closePanels, openNav, updateResponsivePanels } from "./panels";
import { hideSelectionAction } from "./selection-ui";
import { showToast } from "./toast";

export function clearLegacyCredentials(): void {
  LEGACY_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function setSession(role: "viewer" | "admin" | null): void {
  state.session.authenticated = role !== null;
  state.session.role = role;
  state.session.isAdmin = role === "admin";
  ui.roleBadge.textContent = role === "admin" ? "管理模式" : "审阅者";
  ui.roleBadge.classList.toggle("admin", role === "admin");
}

export function showGate(message = ""): void {
  closeModal(false);
  closePanels(false);
  hideSelectionAction();
  ui.app.hidden = true;
  ui.gate.hidden = false;
  ui.loginError.textContent = message;
  ui.password.value = "";
  window.setTimeout(() => ui.password.focus(), 0);
}

export function showApp(): void {
  ui.gate.hidden = true;
  ui.app.hidden = false;
  updateResponsivePanels();
}

export function hardLogout(message = "登录已失效，请重新进入"): void {
  abortEditor();
  closeHistory();
  setSession(null);
  state.comments = [];
  state.allComments = [];
  state.markdownCache.clear();
  state.contentRelease.clear();
  clearLegacyCredentials();
  showGate(message);
}

export function getAuthor(): string {
  return ui.authorName.value.trim();
}

export function requireAuthor(): boolean {
  if (getAuthor()) return true;
  showToast("请先填写署名，再提交意见", "error");
  if (window.innerWidth <= MOBILE_BREAKPOINT) openNav();
  window.setTimeout(() => ui.authorName.focus(), 200);
  return false;
}

export function showModalError(error: unknown, fallback: string): void {
  if (error instanceof ApiError && error.status === 401) {
    closeModal(false);
    hardLogout();
    return;
  }
  ui.modalError.textContent = error instanceof Error ? error.message : fallback;
}

export function handleError(error: unknown, fallback: string): void {
  if (error instanceof ApiError && error.status === 401) {
    hardLogout();
    return;
  }
  showToast(error instanceof Error ? error.message : fallback, "error");
}
